import { ContactUsForm } from "./components";

const ContactUsModal = () => {
  return <ContactUsForm />;
};

export { ContactUsModal };
